import * as ActionTypes from './ActionTypes';

// The auth reducer. The starting state sets authentication
// based on a token being in local storage. In a real app,
// we would also want a util to check if the token is expired.
export const Auth = (state = {
        isLoading: false,
        isAuthenticated: localStorage.getItem('token') ? true : false,
        token: localStorage.getItem('token'),
        user: localStorage.getItem('username') ? localStorage.getItem('username') : null,
        errMess: null,
        verified: localStorage.getItem('verified'),
        recorded: localStorage.getItem('recorded')
    }, action) => {
        // console.log("Inside authUser\n\n",JSON.stringify(action));
    switch (action.type) {
        case ActionTypes.LOGIN_REQUEST:
            return {...state,
                isLoading: true,
                isAuthenticated: false,
                user: action.creds
            };
        case ActionTypes.LOGIN_SUCCESS:
            return {...state,
                isLoading: false,
                isAuthenticated: true,
                errMess: '',
                token: action.token
            };
        case ActionTypes.LOGIN_FAILURE:
            return {...state,
                isLoading: false,
                isAuthenticated: false,
                errMess: action.message
            };
        case ActionTypes.LOGOUT_REQUEST:
            return {...state,
                isLoading: true,
                isAuthenticated: true
            };
        case ActionTypes.LOGOUT_SUCCESS:
            return {...state,
                isLoading: false,
                isAuthenticated: false,
                token: '',
                user: null,
                verified:null,
                recorded:null
            };
        case ActionTypes.GET_STATS:
            // console.log("Trying to get stats\n\n",action.verified);
            return {
                ...state,
                verified:action.payload.verified,
                recorded:action.payload.recorded
            }
        default:
            // console.log("asdsadasdasdasda ");
            return state;
    }
}